import androidx.compose.runtime.CompositionLocalProvider
import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.navigation.RoutePrefix
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.silk.defer.renderWithDeferred
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.renderComposable

public fun main() {
    RoutePrefix.set("/droidcon-sf-24/")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.register("/") { dev.bitspittle.droidconSf24.pages.HomePage() }
        ctx.router.register("/sections/conclusion/additional") {
                dev.bitspittle.droidconSf24.pages.sections.conclusion.AdditionalPage() }
        ctx.router.register("/sections/conclusion/additional2") {
                dev.bitspittle.droidconSf24.pages.sections.conclusion.Additional2Page() }
        ctx.router.register("/sections/conclusion/additional3") {
                dev.bitspittle.droidconSf24.pages.sections.conclusion.Additional3Page() }
        ctx.router.register("/sections/conclusion/community") {
                dev.bitspittle.droidconSf24.pages.sections.conclusion.CommunityPage() }
        ctx.router.register("/sections/conclusion/community2") {
                dev.bitspittle.droidconSf24.pages.sections.conclusion.Community2Page() }
        ctx.router.register("/sections/conclusion/community3") {
                dev.bitspittle.droidconSf24.pages.sections.conclusion.Community3Page() }
        ctx.router.register("/sections/conclusion/community4") {
                dev.bitspittle.droidconSf24.pages.sections.conclusion.Community4Page() }
        ctx.router.register("/sections/conclusion/header") {
                dev.bitspittle.droidconSf24.pages.sections.conclusion.HeaderPage() }
        ctx.router.register("/sections/conclusion/recap") {
                dev.bitspittle.droidconSf24.pages.sections.conclusion.RecapPage() }
        ctx.router.register("/sections/conclusion/reveal") {
                dev.bitspittle.droidconSf24.pages.sections.conclusion.RevealPage() }
        ctx.router.register("/sections/conclusion/reveal2") {
                dev.bitspittle.droidconSf24.pages.sections.conclusion.Reveal2Page() }
        ctx.router.register("/sections/conclusion/reveal3") {
                dev.bitspittle.droidconSf24.pages.sections.conclusion.Reveal3Page() }
        ctx.router.register("/sections/conclusion/reveal4") {
                dev.bitspittle.droidconSf24.pages.sections.conclusion.Reveal4Page() }
        ctx.router.register("/sections/conclusion/thank-you") {
                dev.bitspittle.droidconSf24.pages.sections.conclusion.ThankYouPage() }
        ctx.router.register("/sections/conclusion/thank-you2") {
                dev.bitspittle.droidconSf24.pages.sections.conclusion.ThankYou2Page() }
        ctx.router.register("/sections/html/cm-pvs-compose-html") {
                dev.bitspittle.droidconSf24.pages.sections.html.CMPvsComposeHtmlPage() }
        ctx.router.register("/sections/html/header") {
                dev.bitspittle.droidconSf24.pages.sections.html.HeaderPage() }
        ctx.router.register("/sections/html/html2-compose") {
                dev.bitspittle.droidconSf24.pages.sections.html.Html2ComposePage() }
        ctx.router.register("/sections/html/html2-compose1") {
                dev.bitspittle.droidconSf24.pages.sections.html.Html2Compose1Page() }
        ctx.router.register("/sections/html/html2-compose2") {
                dev.bitspittle.droidconSf24.pages.sections.html.Html2Compose2Page() }
        ctx.router.register("/sections/html/html2-compose3") {
                dev.bitspittle.droidconSf24.pages.sections.html.Html2Compose3Page() }
        ctx.router.register("/sections/html/html2-compose4") {
                dev.bitspittle.droidconSf24.pages.sections.html.Html2Compose4Page() }
        ctx.router.register("/sections/html/html2-compose6") {
                dev.bitspittle.droidconSf24.pages.sections.html.Html2Compose6Page() }
        ctx.router.register("/sections/intro/caution") {
                dev.bitspittle.droidconSf24.pages.sections.intro.CautionPage() }
        ctx.router.register("/sections/intro/example-sites") {
                dev.bitspittle.droidconSf24.pages.sections.intro.ExampleSitesPage() }
        ctx.router.register("/sections/intro/example-sites1") {
                dev.bitspittle.droidconSf24.pages.sections.intro.ExampleSites1Page() }
        ctx.router.register("/sections/intro/example-sites2") {
                dev.bitspittle.droidconSf24.pages.sections.intro.ExampleSites2Page() }
        ctx.router.register("/sections/intro/example-sites3") {
                dev.bitspittle.droidconSf24.pages.sections.intro.ExampleSites3Page() }
        ctx.router.register("/sections/intro/example-sites4") {
                dev.bitspittle.droidconSf24.pages.sections.intro.ExampleSites4Page() }
        ctx.router.register("/sections/intro/example-sites5") {
                dev.bitspittle.droidconSf24.pages.sections.intro.ExampleSites5Page() }
        ctx.router.register("/sections/intro/title") {
                dev.bitspittle.droidconSf24.pages.sections.intro.TitlePage() }
        ctx.router.register("/sections/kobweb/basics/architecture") {
                dev.bitspittle.droidconSf24.pages.sections.kobweb.basics.ArchitecturePage() }
        ctx.router.register("/sections/kobweb/basics/header") {
                dev.bitspittle.droidconSf24.pages.sections.kobweb.basics.HeaderPage() }
        ctx.router.register("/sections/kobweb/basics/install-kobweb") {
                dev.bitspittle.droidconSf24.pages.sections.kobweb.basics.InstallKobwebPage() }
        ctx.router.register("/sections/kobweb/basics/kobweb-cli") {
                dev.bitspittle.droidconSf24.pages.sections.kobweb.basics.KobwebCliPage() }
        ctx.router.register("/sections/kobweb/basics/kobweb-cli2") {
                dev.bitspittle.droidconSf24.pages.sections.kobweb.basics.KobwebCli2Page() }
        ctx.router.register("/sections/kobweb/basics/kobweb-cli3") {
                dev.bitspittle.droidconSf24.pages.sections.kobweb.basics.KobwebCli3Page() }
        ctx.router.register("/sections/kobweb/basics/kobweb-cli4") {
                dev.bitspittle.droidconSf24.pages.sections.kobweb.basics.KobwebCli4Page() }
        ctx.router.register("/sections/kobweb/basics/kobweb-cli5") {
                dev.bitspittle.droidconSf24.pages.sections.kobweb.basics.KobwebCli5Page() }
        ctx.router.register("/sections/kobweb/basics/kobweb-cli6") {
                dev.bitspittle.droidconSf24.pages.sections.kobweb.basics.KobwebCli6Page() }
        ctx.router.register("/sections/kobweb/basics/modifier") {
                dev.bitspittle.droidconSf24.pages.sections.kobweb.basics.ModifierPage() }
        ctx.router.register("/sections/kobweb/basics/modifier1") {
                dev.bitspittle.droidconSf24.pages.sections.kobweb.basics.Modifier1Page() }
        ctx.router.register("/sections/kobweb/basics/modifier2") {
                dev.bitspittle.droidconSf24.pages.sections.kobweb.basics.Modifier2Page() }
        ctx.router.register("/sections/kobweb/basics/modifier3") {
                dev.bitspittle.droidconSf24.pages.sections.kobweb.basics.Modifier3Page() }
        ctx.router.register("/sections/kobweb/basics/modifier4") {
                dev.bitspittle.droidconSf24.pages.sections.kobweb.basics.Modifier4Page() }
        ctx.router.register("/sections/kobweb/basics/modifier6") {
                dev.bitspittle.droidconSf24.pages.sections.kobweb.basics.Modifier6Page() }
        ctx.router.register("/sections/kobweb/basics/modifier7") {
                dev.bitspittle.droidconSf24.pages.sections.kobweb.basics.Modifier7Page() }
        ctx.router.register("/sections/kobweb/basics/page-context") {
                dev.bitspittle.droidconSf24.pages.sections.kobweb.basics.PageContextPage() }
        ctx.router.register("/sections/kobweb/basics/page-context1") {
                dev.bitspittle.droidconSf24.pages.sections.kobweb.basics.PageContext1Page() }
        ctx.router.register("/sections/kobweb/basics/page-context2") {
                dev.bitspittle.droidconSf24.pages.sections.kobweb.basics.PageContext2Page() }
        ctx.router.register("/sections/kobweb/basics/page-context3") {
                dev.bitspittle.droidconSf24.pages.sections.kobweb.basics.PageContext3Page() }
        ctx.router.register("/sections/kobweb/basics/page-context4") {
                dev.bitspittle.droidconSf24.pages.sections.kobweb.basics.PageContext4Page() }
        ctx.router.register("/sections/kobweb/basics/project-organization") {
                dev.bitspittle.droidconSf24.pages.sections.kobweb.basics.ProjectOrganizationPage() }
        ctx.router.register("/sections/kobweb/basics/project-organization1") {
                dev.bitspittle.droidconSf24.pages.sections.kobweb.basics.ProjectOrganization1Page()
                }
        ctx.router.register("/sections/kobweb/basics/project-organization10") {
                dev.bitspittle.droidconSf24.pages.sections.kobweb.basics.ProjectOrganization10Page()
                }
        ctx.router.register("/sections/kobweb/basics/project-organization2") {
                dev.bitspittle.droidconSf24.pages.sections.kobweb.basics.ProjectOrganization2Page()
                }
        ctx.router.register("/sections/kobweb/basics/project-organization3") {
                dev.bitspittle.droidconSf24.pages.sections.kobweb.basics.ProjectOrganization3Page()
                }
        ctx.router.register("/sections/kobweb/basics/project-organization4") {
                dev.bitspittle.droidconSf24.pages.sections.kobweb.basics.ProjectOrganization4Page()
                }
        ctx.router.register("/sections/kobweb/basics/project-organization5") {
                dev.bitspittle.droidconSf24.pages.sections.kobweb.basics.ProjectOrganization5Page()
                }
        ctx.router.register("/sections/kobweb/basics/project-organization6") {
                dev.bitspittle.droidconSf24.pages.sections.kobweb.basics.ProjectOrganization6Page()
                }
        ctx.router.register("/sections/kobweb/basics/routing") {
                dev.bitspittle.droidconSf24.pages.sections.kobweb.basics.RoutingPage() }
        ctx.router.register("/sections/kobweb/basics/routing1") {
                dev.bitspittle.droidconSf24.pages.sections.kobweb.basics.Routing1Page() }
        ctx.router.register("/sections/kobweb/basics/routing10") {
                dev.bitspittle.droidconSf24.pages.sections.kobweb.basics.Routing10Page() }
        ctx.router.register("/sections/kobweb/basics/routing11") {
                dev.bitspittle.droidconSf24.pages.sections.kobweb.basics.Routing11Page() }
        ctx.router.register("/sections/kobweb/basics/routing2") {
                dev.bitspittle.droidconSf24.pages.sections.kobweb.basics.Routing2Page() }
        ctx.router.register("/sections/kobweb/basics/routing3") {
                dev.bitspittle.droidconSf24.pages.sections.kobweb.basics.Routing3Page() }
        ctx.router.register("/sections/kobweb/basics/routing4") {
                dev.bitspittle.droidconSf24.pages.sections.kobweb.basics.Routing4Page() }
        ctx.router.register("/sections/kobweb/basics/routing5") {
                dev.bitspittle.droidconSf24.pages.sections.kobweb.basics.Routing5Page() }
        ctx.router.register("/sections/kobweb/basics/routing6") {
                dev.bitspittle.droidconSf24.pages.sections.kobweb.basics.Routing6Page() }
        ctx.router.register("/sections/kobweb/basics/routing7") {
                dev.bitspittle.droidconSf24.pages.sections.kobweb.basics.Routing7Page() }
        ctx.router.register("/sections/kobweb/basics/routing8") {
                dev.bitspittle.droidconSf24.pages.sections.kobweb.basics.Routing8Page() }
        ctx.router.register("/sections/kobweb/basics/routing9") {
                dev.bitspittle.droidconSf24.pages.sections.kobweb.basics.Routing9Page() }
        ctx.router.register("/sections/kobweb/basics/why-kobweb") {
                dev.bitspittle.droidconSf24.pages.sections.kobweb.basics.WhyKobwebPage() }
        ctx.router.register("/sections/kobweb/basics/why-kobweb2") {
                dev.bitspittle.droidconSf24.pages.sections.kobweb.basics.WhyKobweb2Page() }
        ctx.router.register("/sections/kobweb/basics/why-kobweb3") {
                dev.bitspittle.droidconSf24.pages.sections.kobweb.basics.WhyKobweb3Page() }
        ctx.router.register("/sections/kobweb/basics/why-kobweb4") {
                dev.bitspittle.droidconSf24.pages.sections.kobweb.basics.WhyKobweb4Page() }
        ctx.router.register("/sections/kobweb/basics/why-kobweb5") {
                dev.bitspittle.droidconSf24.pages.sections.kobweb.basics.WhyKobweb5Page() }
        ctx.router.register("/sections/kobweb/basics/why-kobweb6") {
                dev.bitspittle.droidconSf24.pages.sections.kobweb.basics.WhyKobweb6Page() }
        ctx.router.register("/sections/kobweb/fullstack/api-route") {
                dev.bitspittle.droidconSf24.pages.sections.kobweb.fullstack.ApiRoutePage() }
        ctx.router.register("/sections/kobweb/fullstack/api-route10") {
                dev.bitspittle.droidconSf24.pages.sections.kobweb.fullstack.ApiRoute10Page() }
        ctx.router.register("/sections/kobweb/fullstack/api-route11") {
                dev.bitspittle.droidconSf24.pages.sections.kobweb.fullstack.ApiRoute11Page() }
        ctx.router.register("/sections/kobweb/fullstack/api-route12") {
                dev.bitspittle.droidconSf24.pages.sections.kobweb.fullstack.ApiRoute12Page() }
        ctx.router.register("/sections/kobweb/fullstack/api-route13") {
                dev.bitspittle.droidconSf24.pages.sections.kobweb.fullstack.ApiRoute13Page() }
        ctx.router.register("/sections/kobweb/fullstack/api-route2") {
                dev.bitspittle.droidconSf24.pages.sections.kobweb.fullstack.ApiRoute2Page() }
        ctx.router.register("/sections/kobweb/fullstack/api-route3") {
                dev.bitspittle.droidconSf24.pages.sections.kobweb.fullstack.ApiRoute3Page() }
        ctx.router.register("/sections/kobweb/fullstack/api-route4") {
                dev.bitspittle.droidconSf24.pages.sections.kobweb.fullstack.ApiRoute4Page() }
        ctx.router.register("/sections/kobweb/fullstack/api-route5") {
                dev.bitspittle.droidconSf24.pages.sections.kobweb.fullstack.ApiRoute5Page() }
        ctx.router.register("/sections/kobweb/fullstack/api-route6") {
                dev.bitspittle.droidconSf24.pages.sections.kobweb.fullstack.ApiRoute6Page() }
        ctx.router.register("/sections/kobweb/fullstack/api-route7") {
                dev.bitspittle.droidconSf24.pages.sections.kobweb.fullstack.ApiRoute7Page() }
        ctx.router.register("/sections/kobweb/fullstack/api-route8") {
                dev.bitspittle.droidconSf24.pages.sections.kobweb.fullstack.ApiRoute8Page() }
        ctx.router.register("/sections/kobweb/fullstack/api-route9") {
                dev.bitspittle.droidconSf24.pages.sections.kobweb.fullstack.ApiRoute9Page() }
        ctx.router.register("/sections/kobweb/fullstack/build-script") {
                dev.bitspittle.droidconSf24.pages.sections.kobweb.fullstack.BuildScriptPage() }
        ctx.router.register("/sections/kobweb/fullstack/fullstack-vs-static") {
                dev.bitspittle.droidconSf24.pages.sections.kobweb.fullstack.FullstackVsStaticPage()
                }
        ctx.router.register("/sections/kobweb/fullstack/header") {
                dev.bitspittle.droidconSf24.pages.sections.kobweb.fullstack.HeaderPage() }
        ctx.router.register("/sections/kobweb/markdown/code") {
                dev.bitspittle.droidconSf24.pages.sections.kobweb.markdown.CodePage() }
        ctx.router.register("/sections/kobweb/markdown/code1") {
                dev.bitspittle.droidconSf24.pages.sections.kobweb.markdown.Code1Page() }
        ctx.router.register("/sections/kobweb/markdown/code2") {
                dev.bitspittle.droidconSf24.pages.sections.kobweb.markdown.Code2Page() }
        ctx.router.register("/sections/kobweb/markdown/front-matter") {
                dev.bitspittle.droidconSf24.pages.sections.kobweb.markdown.FrontMatterPage() }
        ctx.router.register("/sections/kobweb/markdown/header") {
                dev.bitspittle.droidconSf24.pages.sections.kobweb.markdown.HeaderPage() }
        ctx.router.register("/sections/kobweb/markdown/markdown") {
                dev.bitspittle.droidconSf24.pages.sections.kobweb.markdown.MarkdownPage() }
        ctx.router.register("/sections/kobweb/markdown/markdown2") {
                dev.bitspittle.droidconSf24.pages.sections.kobweb.markdown.Markdown2Page() }
        ctx.router.register("/sections/kobweb/markdown/markdown3") {
                dev.bitspittle.droidconSf24.pages.sections.kobweb.markdown.Markdown3Page() }
        ctx.router.register("/sections/kobweb/markdown/markdown4") {
                dev.bitspittle.droidconSf24.pages.sections.kobweb.markdown.Markdown4Page() }
        ctx.router.register("/sections/kobweb/silk/color-mode") {
                dev.bitspittle.droidconSf24.pages.sections.kobweb.silk.ColorModePage() }
        ctx.router.register("/sections/kobweb/silk/color-mode1") {
                dev.bitspittle.droidconSf24.pages.sections.kobweb.silk.ColorMode1Page() }
        ctx.router.register("/sections/kobweb/silk/color-mode2") {
                dev.bitspittle.droidconSf24.pages.sections.kobweb.silk.ColorMode2Page() }
        ctx.router.register("/sections/kobweb/silk/css-style") {
                dev.bitspittle.droidconSf24.pages.sections.kobweb.silk.CssStylePage() }
        ctx.router.register("/sections/kobweb/silk/css-style1") {
                dev.bitspittle.droidconSf24.pages.sections.kobweb.silk.CssStyle1Page() }
        ctx.router.register("/sections/kobweb/silk/css-style2") {
                dev.bitspittle.droidconSf24.pages.sections.kobweb.silk.CssStyle2Page() }
        ctx.router.register("/sections/kobweb/silk/css-style3") {
                dev.bitspittle.droidconSf24.pages.sections.kobweb.silk.CssStyle3Page() }
        ctx.router.register("/sections/kobweb/silk/css-style4") {
                dev.bitspittle.droidconSf24.pages.sections.kobweb.silk.CssStyle4Page() }
        ctx.router.register("/sections/kobweb/silk/css-style5") {
                dev.bitspittle.droidconSf24.pages.sections.kobweb.silk.CssStyle5Page() }
        ctx.router.register("/sections/kobweb/silk/css-style6") {
                dev.bitspittle.droidconSf24.pages.sections.kobweb.silk.CssStyle6Page() }
        ctx.router.register("/sections/kobweb/silk/css-style7") {
                dev.bitspittle.droidconSf24.pages.sections.kobweb.silk.CssStyle7Page() }
        ctx.router.register("/sections/kobweb/silk/css-style8") {
                dev.bitspittle.droidconSf24.pages.sections.kobweb.silk.CssStyle8Page() }
        ctx.router.register("/sections/kobweb/silk/header") {
                dev.bitspittle.droidconSf24.pages.sections.kobweb.silk.HeaderPage() }
        ctx.router.register("/sections/kobweb/silk/icons") {
                dev.bitspittle.droidconSf24.pages.sections.kobweb.silk.IconsPage() }
        ctx.router.register("/sections/kobweb/silk/icons1") {
                dev.bitspittle.droidconSf24.pages.sections.kobweb.silk.Icons1Page() }
        ctx.router.register("/sections/kobweb/silk/icons2") {
                dev.bitspittle.droidconSf24.pages.sections.kobweb.silk.Icons2Page() }
        ctx.router.register("/sections/kobweb/silk/icons3") {
                dev.bitspittle.droidconSf24.pages.sections.kobweb.silk.Icons3Page() }
        ctx.router.register("/sections/kobweb/silk/responsive") {
                dev.bitspittle.droidconSf24.pages.sections.kobweb.silk.ResponsivePage() }
        ctx.router.register("/sections/kobweb/silk/responsive1") {
                dev.bitspittle.droidconSf24.pages.sections.kobweb.silk.Responsive1Page() }
        ctx.router.register("/sections/kobweb/silk/widgets") {
                dev.bitspittle.droidconSf24.pages.sections.kobweb.silk.WidgetsPage() }
        ctx.router.register("/sections/kobweb/silk/widgets1") {
                dev.bitspittle.droidconSf24.pages.sections.kobweb.silk.Widgets1Page() }
        ctx.router.register("/sections/kobweb/silk/widgets2") {
                dev.bitspittle.droidconSf24.pages.sections.kobweb.silk.Widgets2Page() }
        ctx.router.register("/sections/kobweb/silk/widgets4") {
                dev.bitspittle.droidconSf24.pages.sections.kobweb.silk.Widgets4Page() }
        ctx.router.register("/sections/kobweb/silk/widgets6") {
                dev.bitspittle.droidconSf24.pages.sections.kobweb.silk.Widgets6Page() }
        ctx.router.register("/sections/kobweb/silk/widgets7") {
                dev.bitspittle.droidconSf24.pages.sections.kobweb.silk.Widgets7Page() }
        ctx.router.register("/sections/kobweb/silk/widgets8") {
                dev.bitspittle.droidconSf24.pages.sections.kobweb.silk.Widgets8Page() }
        ctx.router.register("/sections/qand-a") {
                dev.bitspittle.droidconSf24.pages.sections.QandAPage() }

    }
    router.setLegacyRouteRedirectStrategy(Router.LegacyRouteRedirectStrategy.DISALLOW)
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    com.varabyte.kobweb.silk.init.additionalSilkInitialization = { ctx ->
        com.varabyte.kobweb.silk.init.initSilkWidgets(ctx)
        com.varabyte.kobweb.silk.init.initSilkWidgetsKobweb(ctx)
        ctx.theme.registerStyle("fake-color-button-container",
                dev.bitspittle.droidconSf24.components.examples.FakeColorButtonContainerStyle)
        ctx.theme.registerStyle("fake-color-button",
                dev.bitspittle.droidconSf24.components.examples.FakeColorButtonStyle)
        ctx.theme.registerStyle("fake-color-box",
                dev.bitspittle.droidconSf24.components.examples.FakeColorBoxStyle)
        ctx.theme.registerStyle("animate-previews-resize",
                dev.bitspittle.droidconSf24.components.examples.AnimatePreviewsResizeStyle)
        ctx.theme.registerStyle("animate-previews-explode",
                dev.bitspittle.droidconSf24.components.examples.AnimatePreviewsExplodeStyle)
        ctx.theme.registerStyle("colored-square",
                dev.bitspittle.droidconSf24.components.examples.ColoredSquareStyle)
        ctx.theme.registerStyle("rotated-square",
                dev.bitspittle.droidconSf24.components.examples.RotatedSquareStyle)
        ctx.theme.registerStyle("section",
                dev.bitspittle.droidconSf24.components.layouts.SectionStyle)
        ctx.theme.registerStyle("outlined-headers",
                dev.bitspittle.droidconSf24.components.layouts.OutlinedHeadersStyle)
        ctx.theme.registerStyle("accented-subheaders",
                dev.bitspittle.droidconSf24.components.layouts.AccentedSubheadersStyle)
        ctx.theme.registerStyle("android-text",
                dev.bitspittle.droidconSf24.components.widgets.AndroidTextStyle)
        ctx.theme.registerStyle("captioned-text",
                dev.bitspittle.droidconSf24.components.widgets.CaptionedTextStyle)
        ctx.theme.registerStyle("hide-vertical-scrollbar",
                dev.bitspittle.droidconSf24.components.widgets.HideVerticalScrollbar)
        ctx.theme.registerStyle("floating-url",
                dev.bitspittle.droidconSf24.components.widgets.FloatingUrlStyle)
        ctx.theme.registerStyle("folders",
                dev.bitspittle.droidconSf24.components.widgets.FoldersStyle)
        ctx.theme.registerStyle("html-text",
                dev.bitspittle.droidconSf24.components.widgets.HtmlTextStyle)
        ctx.theme.registerStyle("image", dev.bitspittle.droidconSf24.components.widgets.ImageStyle)
        ctx.theme.registerStyle("kobweb-text",
                dev.bitspittle.droidconSf24.components.widgets.KobwebTextStyle)
        ctx.theme.registerStyle("kotlin-text",
                dev.bitspittle.droidconSf24.components.widgets.KotlinTextStyle)
        ctx.theme.registerStyle("live-reloading-indicator",
                dev.bitspittle.droidconSf24.components.widgets.LiveReloadingIndicatorStyle)
        ctx.theme.registerStyle("live-reloading-indicator-spinning-web",
                dev.bitspittle.droidconSf24.components.widgets.LiveReloadingIndicatorSpinningWebStyle)
        ctx.theme.registerStyle("live-reloading-indicator-text",
                dev.bitspittle.droidconSf24.components.widgets.LiveReloadingIndicatorTextStyle)
        ctx.theme.registerStyle("url-bar-container",
                dev.bitspittle.droidconSf24.components.widgets.UrlBarContainerStyle)
        ctx.theme.registerStyle("url-area",
                dev.bitspittle.droidconSf24.components.widgets.UrlAreaStyle)
        ctx.theme.registerStyle("url-icon",
                dev.bitspittle.droidconSf24.components.widgets.UrlIconStyle)
        ctx.theme.registerStyle("disabled-url-icon",
                dev.bitspittle.droidconSf24.components.widgets.DisabledUrlIconStyle)
        ctx.theme.registerKeyframes("animation-transition-color",
                dev.bitspittle.droidconSf24.components.examples.AnimationTransitionColorKeyframes)
        ctx.theme.registerKeyframes("animation-transition-cursor",
                dev.bitspittle.droidconSf24.components.examples.AnimationTransitionCursorKeyframes)
        ctx.theme.registerKeyframes("animation-spinning",
                dev.bitspittle.droidconSf24.components.examples.AnimationSpinningKeyframes)
        ctx.theme.registerKeyframes("animation-squash",
                dev.bitspittle.droidconSf24.components.examples.AnimationSquashKeyframes)
        ctx.theme.registerKeyframes("responsive-resizing-keyframes-size",
                dev.bitspittle.droidconSf24.components.examples.ResponsiveResizingKeyframesSize)
        ctx.theme.registerKeyframes("responsive-resizing-keyframes-color",
                dev.bitspittle.droidconSf24.components.examples.ResponsiveResizingKeyframesColor)
        ctx.theme.registerKeyframes("explode-previews",
                dev.bitspittle.droidconSf24.components.examples.ExplodePreviewsKeyframes)
        ctx.theme.registerKeyframes("hover-color",
                dev.bitspittle.droidconSf24.components.examples.HoverColorKeyframes)
        ctx.theme.registerKeyframes("hover-cursor",
                dev.bitspittle.droidconSf24.components.examples.HoverCursorKeyframes)
        ctx.theme.registerKeyframes("spin",
                dev.bitspittle.droidconSf24.components.widgets.SpinAnimation)
        dev.bitspittle.droidconSf24.initSilk(ctx)
        dev.bitspittle.droidconSf24.components.widgets.initCodeStyles(ctx)
        dev.bitspittle.droidconSf24.styles.initSilk(ctx)
    }

    // For SEO, we may bake the contents of a page in at build time. However, we will
    // overwrite them the first time we render this page with their composable, dynamic
    // versions. Think of this as poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    router.navigateTo(window.location.href.removePrefix(window.location.origin),
            UpdateHistoryMode.REPLACE)

    val root = document.getElementById("root")!!
    while (root.firstChild != null) { root.removeChild(root.firstChild!!) }

    AppGlobals.initialize(mapOf("title" to "DroidconSF24 Presentation", "show-slide-numbers" to
            "false", "remember-last-slide" to "false"))
    renderComposable(rootElementId = "root") {
        dev.bitspittle.droidconSf24.AppEntry {
            router.renderActivePage { renderWithDeferred { it() } }
        }
    }
}
